import $ from 'jquery';

function MuseumYearLoadInit() {
  var selector = '.timeline-year';
  var selectorM = '#timeline-year-m';
  var container = '#museum-timeline';
  $(document).on('click', selector, function () {
    var url = $(this).attr("data-url");
    $.ajax({
      type: "POST",
      url: url,
      data: {},
      crossDomain: true,
      headers: {'X-Requested-With':'XMLHttpRequest'},
      success: function (ret) {
        $(container).html(ret);
      }
    });
  });
  $(document).on('change', selectorM, function (e) {
    e.preventDefault();
    var option = $(this).find(':selected');
    var url = option.attr('data-url');
    $.ajax({
      type: "POST",
      url: url,
      data: {},
      crossDomain: true,
      headers: {'X-Requested-With':'XMLHttpRequest'},
      success: function (ret) {
        $(container).html(ret);
      }
    });
  });
}

function MuseumSportFilterInit() {
  var selector = '.timeline-sport-filter-chk';
  var selectorM = '#timeline-sport-filter-sel';
  $(document).on('click', selector, function () {
    var url = $(this).attr('data-href');
    location.href = url;
  });
  // mobile view
  $(document).on('change', selectorM, function (e) {
    e.preventDefault();
    var option = $(this).find(':selected');
    var url = option.attr('data-href');
    location.href = url;
  });
}

$(document).ready(function () {
  console.log("frontend: museum ready");

  MuseumYearLoadInit();
  MuseumSportFilterInit();
});
